import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getCurrentUser, logout as apiLogout } from '../api/auth';
import { clearToken, clearImpersonation, isAuthenticated, redirectToLogin } from '../utils/auth';
import type { User } from '../types';

export function useAuth() {
  const queryClient = useQueryClient();

  const {
    data: user,
    isLoading,
    error,
  } = useQuery<User>({
    queryKey: ['user'],
    queryFn: getCurrentUser,
    enabled: isAuthenticated(),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  const logout = async () => {
    try {
      await apiLogout();
    } catch {
      // Continue logout even if API fails
    } finally {
      clearToken();
      clearImpersonation();
      queryClient.clear();
      redirectToLogin();
    }
  };

  return {
    user,
    isLoading,
    isAuthenticated: isAuthenticated() && !!user,
    error,
    logout,
  };
}
